import { CargoCompanyAddressListItem } from "../../../../../../common/services/cargo-company/address/list/cargo-company-address-list";
import CargoAddressListingItem from "../types/cargo-address-listing-item";

const createListingItem = (
  responseDataItem: CargoCompanyAddressListItem,
): CargoAddressListingItem => {
  return {
    uuid: responseDataItem.id,
    description: responseDataItem.description ?? "",
    country: responseDataItem.country ?? "",
    town: responseDataItem.town ?? "",
    zipCode: responseDataItem.zipCode ?? "",
    street: responseDataItem.street ?? "",
    houseApartmentNumber: responseDataItem.apartment
      ? `${responseDataItem.houseNumber}/${responseDataItem.apartment}`
      : responseDataItem.houseNumber
        ? `${responseDataItem.houseNumber}`
        : "",
    geoCoordinates: `${responseDataItem.lat};${responseDataItem.lon}`,
    type: responseDataItem.cargoAddressType,
  };
};

const createListingItems = (
  responseDataItems: CargoCompanyAddressListItem[],
): CargoAddressListingItem[] => {
  const result = responseDataItems.map(createListingItem);
  return result;
};

const cargoAddressListingFactory = {
  createListingItems,
};

export default cargoAddressListingFactory;
